module.exports = __webpack_public_path__ + "static/img/pros-1.3f0e763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pros-1.png
// module id = FmZB
// module chunks = 1